// utils/AlertManager.ts
export type AlertParams = {
  type: "success" | "error" | "warning";
  title: string;
  message: string;
  source?: string;
};

type AlertHandler = (params: AlertParams) => void;

class AlertManager {
  private static _instance: AlertManager;
  private _handler?: AlertHandler;
  private _queue: { params: AlertParams; onConfirm?: () => void }[] = [];
  private _current?: { params: AlertParams; onConfirm?: () => void } | null =
    null;

  static get instance() {
    if (!AlertManager._instance) AlertManager._instance = new AlertManager();
    return AlertManager._instance;
  }

  /** Register modal/UI handler (called once from App.tsx) */
  registerHandler(fn: AlertHandler) {
    this._handler = fn;
  }

  /** Called anywhere to enqueue an alert */
  showAlert(params: AlertParams, onConfirm?: () => void) {
    this._queue.push({ params, onConfirm });
    if (!this._current) this._displayNext();
  }

  /** Called by AlertModal when OK is clicked */
  confirm() {
    if (this._current?.onConfirm) this._current.onConfirm();
    this._current = null;
    this._displayNext();
  }

  private _displayNext() {
    if (this._queue.length === 0) return;
    const next = this._queue.shift();
    if (!next) return;
    this._current = next;
    this._handler?.(next.params);
  }
}

export const alertManager = AlertManager.instance;
